import { computed, inject, signal } from '@angular/core';
import { signalStoreFeature, type, withProps } from '@ngrx/signals';
import {
  GetUserBodyMassIndexInfoEndpoint,
  SetOrderBodyMassIndexInfoOrTreatmentStartDataEndpoint,
} from '@pims-endpoints';
import { Bmi } from '@types-lib';
import { ENVIRONMENT } from 'environments';

export function withBmiStoreProps<_>() {
  return signalStoreFeature(
    {
      state: type<Bmi.BmiStoreState>(),
    },
    withProps(({ itemBeingEditedId, bmiItemEntityMap }) => ({
      _environment: inject(ENVIRONMENT),
      _updateTreatmentStartInfoTrigger: signal(undefined),
      _updateBmiItemTrigger: signal(undefined),
      _itemBeingEdited: computed(
        () => (itemBeingEditedId() !== null && bmiItemEntityMap()[itemBeingEditedId() as number]) || null,
      ),
      _setTreatmentStartDataEndpoint: new SetOrderBodyMassIndexInfoOrTreatmentStartDataEndpoint(),
      _getUserBodyMassIndexInfoEndpoint: new GetUserBodyMassIndexInfoEndpoint(),
      _setOrderBodyMassIndexInfoEndpoint: new SetOrderBodyMassIndexInfoOrTreatmentStartDataEndpoint(),
    })),
  );
}
